export enum CatalogSearchResultDisplayType {
	List = 1,
	Catalog = 2
}